import { Check, X, Star, Image as ImageIcon } from "lucide-react";

/**
 * Barre d'actions principale d'une carte Artwork.
 * 4 boutons : Valider (proposition #1) · Permanent · Refuser · Autres.
 */
export function ArtworkActions({
  radioId,
  hasTrack,
  busy,
  loadingAlt,
  validated,
  suggestions,
  onValidate,
  onReject,
  onToggleAlt,
}) {
  const firstSuggestion = suggestions[0];
  const canValidate = hasTrack && !busy && !!firstSuggestion;
  const canReject = hasTrack && !busy && !!validated;
  const canFetchAlt = hasTrack && !busy && !loadingAlt;

  return (
    <div className="art-card-actions">
      <button
        type="button"
        className="art-action art-action-validate"
        disabled={!canValidate}
        onClick={() => onValidate(firstSuggestion?.artwork_url, firstSuggestion?.source, false)}
        data-testid={`art-validate-${radioId}`}
        title="Valider la proposition n°1"
      >
        <Check size={14} /> Valider
      </button>
      <button
        type="button"
        className="art-action art-action-permanent"
        disabled={!canValidate}
        onClick={() => onValidate(firstSuggestion?.artwork_url, firstSuggestion?.source, true)}
        title="Marquer comme pochette définitive"
      >
        <Star size={14} /> Permanent
      </button>
      <button
        type="button"
        className="art-action art-action-reject"
        disabled={!canReject}
        onClick={onReject}
        title="Supprimer la validation actuelle"
      >
        <X size={14} /> Refuser
      </button>
      <button
        type="button"
        className="art-action art-action-alt"
        disabled={!canFetchAlt}
        onClick={onToggleAlt}
        title="Voir les autres propositions (iTunes + Deezer + MusicBrainz + Discogs + Last.fm + Fanart.tv)"
      >
        <ImageIcon size={14} /> {loadingAlt ? "Chargement…" : "Autres"}
      </button>
    </div>
  );
}
